import FanMessagePage from "./FanMessagePage";

export default FanMessagePage;
